import type { NpcCreature } from './types';
import { computeStage, shouldDieOfOldAge } from '@/domain/lifecycle';
import { NPC_TIME_SCALE } from '@/domain/care/constants';

export interface TickNpcResult {
  npc: NpcCreature;
  died: boolean;
  stageChanged: boolean;
}

/** Avança idade do NPC. Pode morrer só por old-age em U2. */
export function tickNpc(npc: NpcCreature, _dtMs: number, nowMs: number): TickNpcResult {
  if (npc.dead) return { npc, died: false, stageChanged: false };
  const ageMs = (nowMs - npc.bornAt) * NPC_TIME_SCALE;
  const newStage = computeStage(ageMs);
  const stageChanged = newStage !== npc.stage;
  let elderSince = npc.elderSince;
  if (newStage === 'elder' && elderSince === null) {
    elderSince = nowMs;
  }
  const lifecycle = {
    stage: newStage,
    bornAt: npc.bornAt,
    elderSince,
    teenEntryProfile: null,
    careTier: null,
    careFinalScore: null,
  };
  let dead = false;
  if (newStage === 'elder' && shouldDieOfOldAge(lifecycle, nowMs)) {
    dead = true;
  }
  return {
    npc: {
      ...npc,
      stage: dead ? 'dead' : newStage,
      elderSince,
      dead,
      diedAt: dead ? nowMs : npc.diedAt,
      causeOfDeath: dead ? 'old-age' : npc.causeOfDeath,
    },
    died: dead,
    stageChanged: stageChanged || dead,
  };
}
